import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Image, ScrollArea, Stack, Text } from '@mantine/core';
import { ProfileCharacter } from './ProfileCharacter';
import { ProfileRegistration } from './ProfileRegistration';
export const ProfileIntroMobile: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <ScrollArea h="calc(100vh - 310px)" hiddenFrom="sm">
      <Stack pb={40} px="md">
        <Image src="/assets/kyc/lock.svg" alt="lock" w={80} h={80} mx="auto" />
        <Box>
          <Text fz={28} c="var(--text-prime)" className={gunterzBold.className} ta="center">
            {i18n._('unlock ')}
            <Text c="var(--text-white)" span inherit>
              {i18n._('your primeorb’s full power!')}
            </Text>
          </Text>
        </Box>

        <Divider size="sm" c="var(--icon-primary)" />

        <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} ta="center" style={{
        wordBreak: 'break-word'
      }}>
          {i18n._('Your PrimeOrb is waiting to level up! Complete the verification process to unlock powerful Legendary Armor and boost your rewards. It’s your time to gear up and start reaping the benefits!')}
        </Text>

        <ProfileCharacter />

        <ProfileRegistration />
      </Stack>
    </ScrollArea>;
};